/** Client-side: candidates already in ATS for a client (mirrors server clientAts.js). */

function normId(value) {
  return String(value ?? '').trim();
}

export function candidateIdsInClientAtsFromData(applications = [], jobs = [], clientId) {
  const target = normId(clientId);
  if (!target) return new Set();

  const jobsMap = new Map(jobs.map(j => [normId(j.id), j]));
  const clientJobIds = new Set(
    jobs.filter(j => normId(j.clientId) === target).map(j => normId(j.id)).filter(Boolean)
  );

  const ids = new Set();
  for (const app of applications) {
    if (!app.candidateId) continue;
    if (String(app.stage || '').toLowerCase() === 'rejected') continue;

    let appClientId = normId(app.clientId);
    if (!appClientId && app.jobId) {
      appClientId = normId(jobsMap.get(normId(app.jobId))?.clientId);
    }

    const onClient =
      appClientId === target || (app.jobId && clientJobIds.has(normId(app.jobId)));
    if (onClient) ids.add(app.candidateId);
  }
  return ids;
}
